import dayjs from 'dayjs';
import { tKeys, useTranslation } from 'locales';
import { capitalize } from 'remeda';
import type { Sync } from 'shared/hooks/use-load-syncs';

const TIME_FORMAT = 'HH:mm';
const DATE_FORMAT = 'DD/MM';
const WEEKDAY_FORMAT = 'dddd';

export const useLastSyncLabel = () => {
  const { t } = useTranslation();

  return ({ lastSuccessAt }: Sync): string | null => {
    if (lastSuccessAt === null) return t(tKeys.NAV.SYNC.LAST_SYNC_NEVER);

    const now = dayjs();

    if (lastSuccessAt.isSame(now, 'day')) return null;

    const time = lastSuccessAt.format(TIME_FORMAT);

    if (lastSuccessAt.isSame(now.subtract(1, 'day'), 'day')) {
      return t(tKeys.NAV.SYNC.LAST_SYNC_YESTERDAY, { time });
    }

    if (lastSuccessAt.isAfter(now.subtract(1, 'week'))) {
      return t(tKeys.NAV.SYNC.LAST_SYNC_WEEKDAY, {
        weekday: capitalize(lastSuccessAt.format(WEEKDAY_FORMAT)),
        time,
      });
    }

    return t(tKeys.NAV.SYNC.LAST_SYNC_DATE, { date: lastSuccessAt.format(DATE_FORMAT), time });
  };
};
